import { Cart } from "@/types";
import { atom } from "jotai";

export const lastSyncedCartAtom = atom<Cart | null>(null)
